import { useParams } from "react-router";
import RisikoanalyseFormView from "../components/RisikoanalyseFormView";

const PublicCustomerRisikoanalyseForm = () => {
  const { token } = useParams();
  return <RisikoanalyseFormView token={token} chrome="public" />;
};

export default PublicCustomerRisikoanalyseForm;
